// Search page state kept in the URL (recherche, off = unchecked filters, page, lat/lng/z)
// so that going back from a client page restores the same search and map view.

export const FILTER_KEYS = ['clients', 'prospects', 'visite', 'no_visite', 'projets', 'no_projet'];

export function readState(query) {
  const off = (query.off || '').split(',').filter(Boolean);
  const lat = parseFloat(query.lat);
  const lng = parseFloat(query.lng);
  const zoom = parseInt(query.z, 10);
  const page = parseInt(query.page, 10);
  return {
    filters: Object.fromEntries(FILTER_KEYS.map(key => [key, !off.includes(key)])),
    page: page > 0 ? page : 1,
    view: {
      center: Number.isFinite(lat) && Number.isFinite(lng) ? [lat, lng] : null,
      zoom: Number.isFinite(zoom) ? zoom : null,
    },
  };
}

// view: { lat, lng, zoom } or null
export function buildQuery(search, page, view) {
  const query = {};
  if (search.query) { query.recherche = search.query; }
  const off = FILTER_KEYS.filter(key => !search[key]);
  if (off.length) { query.off = off.join(','); }
  if (page > 1) { query.page = String(page); }
  if (view) {
    query.lat = view.lat.toFixed(5);
    query.lng = view.lng.toFixed(5);
    query.z = String(view.zoom);
  }
  return query;
}
